(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-product-engraving-toggle]');
    if (!toggle) return;

    var engraving = toggle.closest('[data-product-engraving]');
    if (!engraving) return;

    var fields = engraving.querySelector('[data-product-engraving-fields]');
    var inputs = engraving.querySelectorAll('input[name^="properties["]');
    var isOpen = toggle.getAttribute('aria-expanded') === 'true';
    var nextOpen = !isOpen;

    toggle.setAttribute('aria-expanded', nextOpen ? 'true' : 'false');
    toggle.textContent = nextOpen ? 'Remove engraving' : 'Add bottle engraving';
    if (fields) fields.hidden = isOpen;

    inputs.forEach(function (input) {
      input.disabled = isOpen;
      if (isOpen) input.value = '';
    });
  });
})();
